module.exports = __webpack_public_path__ + "static/media/bill-dark.3cf77a72.svg";